import React from 'react';
import { Mail } from 'lucide-react';
import athenaLogo from '../assets/athena-logo-white.png';
import npsfLogo from '../assets/npsf-logo-footer.png';
import '../styles.css';
import '../styles/Footer.css';

const NewFooter: React.FC = () => {
  return (
    <footer className='new-footer'>
      <div className='new-footer-content'>
        <div className='new-footer-grid'>
          {/* Logo and Description */}
          <div className='new-footer-logo-section'>
            <img src={athenaLogo} alt='Athena Logo' />
            <p>
              The trusted platform for defense research, education and
              collaboration.
            </p>
          </div>

          {/* Contact Information */}
          <div className='new-footer-contact'>
            <h3>Get in Touch</h3>
            <a
              href='mailto:athena@npsfoundation.org'
              className='new-footer-email'
            >
              <div className='new-footer-email-icon'>
                <Mail />
              </div>
              <span>athena@npsfoundation.org</span>
            </a>

            <div className='new-footer-managed'>
              <h3>Managed By</h3>
              <img src={npsfLogo} alt='NPS Foundation' />
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className='new-footer-bottom'>
          <p>
            © {new Date().getFullYear()} Athena 4 Partners. All rights reserved.
          </p>
          <div className='new-footer-links'>
            <a href='#'>Privacy Policy</a>
            <a href='#'>Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
